import { __assign } from "tslib";
import React, { Fragment } from 'react';
import { IconSVG } from '../icon-svg/icon-svg';
export var IconChevronUp = function (SVGprops) {
    return (React.createElement(IconSVG, __assign({}, SVGprops),
        React.createElement(Fragment, null,
            React.createElement("path", { d: "m3.4 15.9c-.5.5-1.5.5-1.8 0-.2-.2-.2-.2-.4-.4-.2-.3-.2-.5-.2-.5 0-.2 0-.4.2-.5 0-.2 9.9-10.1 9.9-10.1.5-.5 1.5-.5 2 0l9.7 9.5c.5.5.5 1.5 0 2s-1.5.5-1.8 0l-9-8.6z" }))));
};
